module.exports = __webpack_public_path__ + "img/home.38af5564.svg";